import React, { useState, useEffect } from "react";
import { exerciseUrls } from "../public/data.js";
import ClassVideo from "../components/Class/ClassVideo";

interface ExerciseProps {
  title: string;
  originalLinks: {
    url1: string;
    url2: string;
    url3: string;
    url4: string;
    title: string;
    level: string;
    apparatus: string;
    props: string;
    body: string;
  };
}

const Class = ({ title, originalLinks }: ExerciseProps) => {

  return (
    <div id="individual">
      <ClassVideo originalLinks={originalLinks} title={title} />
    </div>
  );
};

export default Class;
